interface EditorResizeTarget {
    cancelAnimationFrame: (handle: number) => void;
    dispatchEvent: (event: Event) => boolean;
    requestAnimationFrame: (callback: FrameRequestCallback) => number;
}

export const scheduleEditorResize = (
    target: EditorResizeTarget = window,
): (() => void) => {
    const handle = target.requestAnimationFrame(() => {
        target.dispatchEvent(new Event("resize"));
    });
    return () => target.cancelAnimationFrame(handle);
};
